import Reveal from "@/components/base/Reveal";
import RevealWords from "@/components/base/RevealWords";
import MagneticButton from "@/components/base/MagneticButton";

export default function BookingForm() {
  return (
    <section
      id="booking"
      className="relative bg-[var(--lum-bg)] py-20 md:py-28 px-6 md:px-12 border-t border-[var(--lum-gold)]/12"
    >
      <div className="max-w-4xl mx-auto">
        <Reveal className="text-center mb-14 md:mb-18">
          <div className="font-label text-[11px] text-[var(--lum-gold)] mb-5">
            体験入部 / 申込み方法
          </div>
          <h2 className="font-jp text-5xl md:text-6xl lg:text-[64px] text-[var(--lum-cream)] mb-6 leading-[1.3] font-medium">
            <RevealWords text="体験入部の申込み" />
          </h2>
        </Reveal>

        {/* Steps */}
        <Reveal className="mb-12" delay={2}>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-0">
            {[
              { step: "STEP 1", label: "フォームから申込" },
              { step: "STEP 2", label: "振込先をご案内" },
              { step: "STEP 3", label: "お振込みで参加確定" },
            ].map((s, i) => (
              <div key={s.step} className="flex flex-col sm:flex-row items-center gap-0 w-full sm:w-auto">
                <div className="flex flex-col items-center p-5 md:p-6 bg-[#e6f0ff] border border-[var(--lum-gold)]/15 rounded-xl w-full sm:w-auto min-w-[120px] md:min-w-[140px] text-center">
                  <div className="font-label text-[9px] text-[var(--lum-gold)] mb-2">{s.step}</div>
                  <div className="font-jp text-base text-[var(--lum-cream)]/80 font-medium">{s.label}</div>
                </div>
                {i < 2 && (
                  <i className="ri-arrow-right-line text-[var(--lum-gold)]/50 text-xl mx-3 hidden sm:block" />
                )}
                {i < 2 && (
                  <i className="ri-arrow-down-line text-[var(--lum-gold)]/50 text-xl my-3 sm:hidden mx-auto" />
                )}
              </div>
            ))}
          </div>
        </Reveal>

        {/* CTA */}
        <Reveal delay={3} className="flex flex-col items-center gap-4">
          <MagneticButton strength={10}>
            <a
              href="https://liff.line.me/2006643111-0P1amynq/landing?follow=%40151ghnox&lp=FeDlOu&liff_id=2006643111-0P1amynq"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-3 px-10 py-5 bg-[var(--lum-gold)] text-white font-jp text-[15px] font-medium hover:bg-[#1d4ed8] transition-all duration-500 cursor-pointer whitespace-nowrap rounded-full hover:-translate-y-0.5"
            >
              <span>体験入部する</span>
              <i className="ri-arrow-right-line text-base transition-transform duration-500 group-hover:translate-x-1"></i>
            </a>
          </MagneticButton>
          <p className="font-jp text-xs text-[var(--lum-cream)]/50">
            フォームから申し込んでいただくと、振込先をご案内します。
          </p>
        </Reveal>
      </div>
    </section>
  );
}